import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { routePath } from '@brightside-web/desktop/data-access/core-services';
import { BrightsideUiModule } from '@brightside/brightside-ui';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'brightside-web-spending-my-money-help-card',
    imports: [BrightsideUiModule, TranslateModule],
    templateUrl: './my-spending-money-help-card.component.html',
    styleUrl: './my-spending-money-help-card.component.scss'
})
export class MySpendingMoneyHelpCardComponent {
  data: { route: string | undefined };
  private _router = inject(Router);

  cellClick() {
    if (this.data?.route) {
      this._router.navigate([this.data?.route]);
    } else {
      this._router.navigate([routePath('my_spending_info_view')]);
    }
  }
}
